export default __webpack_public_path__ + "static/media/cover-3.9f0a1bfb.webp";